import React from "react";

function Shipped() {
  return <div>Shipped</div>;
}

export default Shipped;
